<template>
  <!--脚组件-->
  <div class="footer-com">
    <div class="py-5 d-flex m-auto justify-content-center footer-com-box" style="max-width: 1600px;">
      <div class="d-flex codes align-items-center flex-column my-5">
        <img src="../assets/images/TwentyFiveNewHome/footerlogo.png" alt="" class="logo">
        <div style="color: #fff;" class="written-words">让图像处理更便捷</div>
        <div class="d-flex">
          <div style="width: max-content" class="qrcode">
            <div class="img-box"><img :src="state.qcWeChatCustomerUrl" alt="img-icon"></div>
            <div class="text-white text-center text">官方微信客服群</div>
          </div>
          <div style="width: max-content;" class="qrcode">
            <div class="img-box"><img src="../assets/images/footer/image_code_ewm.png" alt="img-icon"></div>
            <div class="text-white text-center text">公众号二维码</div>
          </div>
          <div style="width: max-content" class="qrcode">
            <div class="img-box"><img src="../assets/images/footer/bc.png" alt="img-icon"></div>
            <div class="text-white text-center text">
              <div>悟空编程</div>
              <div>官方微信客服群</div>
            </div>
          </div>
        </div>
      </div>
      <div class="all-content d-flex">
        <div v-for="(item,index) in state.allContentData" :key="index">
          <div class="text-white title">
            {{ item.title }}
            <div v-for="(i,idx) in item.list" :key="idx" class="text-center cur" @click="gotoPage(i.path)">
              {{ i.name }}
            </div>
            <div v-if="index === 0" class="text-center cur" @click="lastPageClick(state.aigcUrl)">悟空AI</div>
          </div>
        </div>
      </div>
    </div>
    <div style="border-top: 1px solid #333333;width: 100%;"></div>
    <div class="d-flex bottom-url m-auto justify-content-center" style="max-width: 1600px;color: #ccc; ">
     <div class="explain">
      <div class="author text-center fs-14">开发者：北京亦心科技有限公司  联系电话：400-082-0206</div>
      <div class="rule text-center fs-14"> 
        <a target="_blank" :href="state.websiteBaseUrl+'/static/privacy_policy_zh-cn.html'">隐私政策</a> |
        <a target="_blank" :href="state.websiteBaseUrl+'/static/user_agreement_zh-cn.html'">用户协议</a> |
        <a target="_blank" :href="state.websiteBaseUrl+'/static/materialAgreement_zh.html'">授权协议</a>
      </div>
     </div>
     <div>
      <div class="fs-14 phone-center">北京亦心科技有限公司：北京市海淀区海淀大街38号银科大厦11-11</div>
        <div class="fs-14 mt-2 phone-center">
          <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">京ICP备20012926号-1</a> |
          <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">京ICP备20012926号-2</a> |
          <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802041713">
            <img src="../assets/images/footer/image_police_insignia.png" />京公网安备 11010802041713号
          </a>
      </div>
     </div>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import { reactive } from 'vue'
  import { getMultipleData } from '../utils/api'
  const router = useRouter()
const state = reactive({
    aigcUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/home/galleryList', // aigc跳转地址
    allContentData: [
      {
        title: '推荐产品',
        list: [
          { name: '悟空图像', path: '/PhotoSirSoftware' },
          { name: 'AI闪绘', path: '/AiFlashDrawing' },
          { name: '悟空编程', path: '/Program' },
          { name: '悟空套版', path: '/Registering' },
          { name: '悟空看图', path: '/LookPicture' },
          { name: '悟空拼图', path: '/PhotoSplicing' },
          { name: '悟空传图', path: '/PhotoUpload' }
          // { name: '悟空AI', path: '/contact' },
        ]
      },
      {
        title: '关于亦心',
        list: [
          { name: '公司简介', path: '/ContactView' },
          { name: '新闻中心', path: '/CompanyNews' },
          { name: '人才招聘', path: '/ContactView?curretIndex=1' }
        ]
      },
      {
        title: '服务支持',
        list: [
          { name: '活动信息', path: '/ActivityCenter' },
          { name: '在线教程', path: '/VideoTutorial' },
          { name: '联系我们', path: '/ContactView' }
        ]
      },
    ],
    websiteBaseUrl: window.SITE_CONFIG.websiteBaseUrl,
    qcWeChatCustomerUrl: ''
  })
  // 获取微信客服群二维码
const getQcWeChatCustomerUrl = () => {
    let param = {
      systype: 3,
      name: 'photo_sir_wechat_group'
    }
    getMultipleData(param).then(res => {
      if (res.code === 0 && res.data.length !== 0) {
        state.qcWeChatCustomerUrl = res.data[0].value
      }
    })
}
const lastPageClick = (url) => {
  window.open(url, '_blank')
}

getQcWeChatCustomerUrl()
const gotoPage = (path) => {
  router.push(path)
}
</script>

<style lang="scss" scoped>
  .footer-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 0;
    .img-line {
      margin-top: -9px;
    }
    .qr-code-box {
      display: flex;
    }
    .codes{
      margin-right: 200px;
      .logo{
        width: 162px;
        height: 73px;
      }
      .written-words{
        margin: 35px 0;
      }
      .qrcode{
        .img-box{
          border-radius: 12px;
          width: 101px;
          height: 101px;
          background-color: #fff;
          img{
            border-radius: 12px;
            width: 100%;
            height: 100%;
          }
        }
        .text{
          margin-top: 17px;
          font-size: 14px !important;
          color: #CCCCCC !important;
        }
      }
      .qrcode:nth-child(2){
        margin: 0 20px;
      }
    }
    .all-content{
      display: block;
      width: 40%;
      justify-content: space-between;
      .title{
        font-size: 16px;
        font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
      }
      .text-center{
        margin-top: 26px;
        font-size: 14px;
        color: #ccc;
      }
    }
  }
  .bottom-url{
    padding: 37px 0;
    font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
    font-weight: 300;
  }
  .explain{
    margin-right: 200px;
  }
  
  .author{
    margin: 0 0 10px 0;
  }
  a {
  text-decoration: none; /* 移除下划线 */
  color: inherit; /* 继承父元素的文本颜色，或者您可以设置为您想要的任何颜色 */
  outline: none; /* 移除点击时的虚线框（可选） */
}

a:hover {
  text-decoration: underline; /* 可选：在悬停时显示下划线 */
}

a:visited {
  color: inherit; /* 访问过的链接颜色也继承父元素的颜色，或者您可以设置为其他颜色 */
}

a:active {
  color: inherit; /* 被点击时的链接颜色，同样可以设置为其他颜色 */
}
@media (max-width: 567px) {
  .all-content{
    display: none !important;

  }
  .footer-com{
    .footer-com-box{
      padding: 0 !important;
    }
    .codes{
      margin-right: 0 !important;
    }
    .logo{
      width: 70% !important;
      height: auto !important;

    }
  } 
  .bottom-url{
    flex-direction: column;
    .explain{
      margin-right: 0;
    }
    .phone-center{
      text-align: center;
    }
    .phone-center:nth-child(1) {
      margin-top: 30PX;
    }
  }
}
</style>
